import React from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";
import { DataGridItem } from "components/data-grid";
import Select from "@material-ui/core/Select";
import { useAssetFormTypeContext } from "../form-provider";
import DataGrid from "../../../../components/data-grid/data-grid";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import Chip from "@material-ui/core/Chip";
import {ValidatedImageField} from "../../../../components/form/form-imagefield/form-imagefield";
import ImageFieldComponent from "../../../../components/form/form-imagefield/ImageFieldComponent";
import TextField from "@material-ui/core/TextField";

const NewAssetApiForm = ({
  acceptImage = ["image/png", "image/apng"],
  allowedAssetTypes = ["image", "video"],
  disabled = false,
  intl,
  values,
  onChange,
  path = "",
  defaultCategory,
  disabledCategorySelection,
  register,
  assetCategories
}) => {
  const { type, setType } = useAssetFormTypeContext();

  const handleImageChange = value => {
    onChange(`${path}codename`, value.name.split(".")[0]);
    onChange(`${path}image`, value.base64);
    onChange(`${path}categoryIds`, [defaultCategory._id]);
  };

  return (
    <DataGrid>
      <DataGridItem big>
        <FormControl style={{width: '100%'}}>
        <InputLabel id="common.asset.selectCategory">{intl.formatMessage({id: "common.asset.selectCategory"})}</InputLabel>
        <Select {...register(`${path}categoryIds`)}
                disabled={disabledCategorySelection}
                getLabelFromElement={item => item.name}
                getValueFromElement={item => item._id}
                id={`${path}categoryIds`}
                value={[defaultCategory.name]}
                multiple
                input={<Input id="select-multiple-chip" />}
                renderValue={(selected) => (
                    <div>
                      {selected?.map((value) => (
                          <Chip key={value} label={value} />
                      ))}
                    </div>
                )}
        >
          {assetCategories?.map((category) => (
              <MenuItem key={category._id} value={category._id}>
                {category.name}
              </MenuItem>))}
        </Select>
        </FormControl>
      </DataGridItem>
      <DataGridItem big>
        <Select
            disabled={disabled}
            id={`${path}type`}
            name={`${path}type`}
            value={type}
            onChange={event => {
              setType(event.target.value);
              onChange(`${path}image`, "");
              onChange(`${path}codename`, "");
            }}
            getLabelFromElement={type => intl.formatMessage({ id: `asset.type.in.${type}` })}
            style={{width: '100%'}}
        >
          {allowedAssetTypes.map((type) => <MenuItem key={type} value={type}>
            {intl.formatMessage({ id: `asset.type.in.${type}` })}
          </MenuItem>)}
        </Select>
        {type === "image" && acceptImage.includes("image/apng") && <FormattedMessage id="asset.type.animation.size" />}
      </DataGridItem>
      <DataGridItem big>
          <ImageFieldComponent accept={acceptImage.join()}
                               id={`${path}image`}
                               name={`${path}image`}
                               value={values?.image}
                               disabled={disabled}
                               label={intl.formatMessage({ id: "common.asset.selectFile.label" })}
                               onChange={handleImageChange}
                               intl={intl} />
      </DataGridItem>
      {values?.image && (
        <>
          <DataGridItem big>
              <TextField
                  {...register(`${path}codename`)}
                  id={`${path}codename`}
                  type="text"
                  placeholder={intl.formatMessage({ id: "common.name" })}
                  label={intl.formatMessage({ id: "common.name" })}
                  style={{width: '100%'}}
              />
          </DataGridItem>
          <DataGridItem big>
              <TextField
                  {...register(`${path}description`)}
                  id={`${path}description`}
                  type="text"
                  placeholder={intl.formatMessage({ id: "common.description" })}
                  label={intl.formatMessage({ id: "common.description" })}
                  style={{width: '100%'}}
              />
          </DataGridItem>
        </>
      )}
    </DataGrid>
  );
};

NewAssetApiForm.propTypes = {
  /**
   * Path del atributo
   */
  path: PropTypes.string,
  /**
   * Indica si los campos están deshabilitados
   */
  disabled: PropTypes.bool,
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  onChange: PropTypes.func,
  /**
   * Callback que se dispara con el cambio del input de imagen
   */
  onImageChange: PropTypes.func,
  /**
   * Mimetypes de video aceptados ("video/mp4")
   */
  acceptVideo: PropTypes.array,
  /**
   * Mimetypes de imagen aceptados ("image/png", "image/apng")
   */
  acceptImage: PropTypes.array,
  /**
   * Tipos de asset aceptados ("image", "video")
   */
  allowedAssetTypes: PropTypes.array,
  /**
   * Categorías por defecto para la creación del asset
   */
  defaultCategory: PropTypes.string,
  /**
   * Indica si se deshabilita y bloquea la selección de categoría
   */
  disabledCategorySelection: PropTypes.bool,
};

export default injectIntl(NewAssetApiForm);
